import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia'
import { AuthPage, useAuthStore } from '@/stores/auth'
import InputText from '@/components/input/InputText.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPasswordForm',
  setup(__props) {

const authStore = useAuthStore()

const {
  email,
  page,
  hasValidationError,
  requestMessage
} = storeToRefs(authStore)

const submit = async () => {
  if (!email.value) return

  hasValidationError.value = false

  try {
    const response = await authStore.forgotPassword()

    requestMessage.value = response.data?.message ?? 'Er is een e-mail verstuurd met instructies om je wachtwoord te wijzigen.'
    page.value = AuthPage.LOGIN
  } catch (e) {
    if (e?.response?.status === 422) {
      requestMessage.value = 'Er is iets misgegaan bij het wijzigen van je wachtwoord. Probeer het later nog eens.'
      hasValidationError.value = true
      page.value = AuthPage.LOGIN

      return
    }

    console.error(e)
  }
}

return { __sfc: true,authStore, email, page, hasValidationError, requestMessage, submit, AuthPage, InputText }
}

})